import { setHasVenues } from 'actions/authentication';
import { setError } from 'actions/error';
import {
  CreateVenueAPIRequest,
  DefaultVenueAPIRequest,
  FetchAllMenusAPIRequest,
  FetchAuthorisedUsersAPIRequest,
  FetchManagedPagesAPIRequest,
  FetchPageFatsomaAPIRequest,
  QueryAuthorizedVenuesAPIRequest,
  UpdateVenueAPIRequest,
  UploadVenueImageAPIRequest,
  VenueDetailsAPIRequest,
} from 'utils/constants/network';
import { callJSONAPI } from 'utils/jsonapi/network';
import { callAPI } from 'utils/network';

export const REQUEST_DEFAULT_VENUE = 'REQUEST_DEFAULT_VENUE';
export const SET_DEFAULT_VENUE = 'SET_DEFAULT_VENUE';
export const REQUEST_VENUE_DETAILS = 'REQUEST_VENUE_DETAILS';
export const SET_VENUE_DETAILS = 'SET_VENUE_DETAILS';
export const REQUEST_ALL_MENUS = 'REQUEST_ALL_MENUS';
export const RECEIVE_ALL_MENUS = 'RECEIVE_ALL_MENUS';
export const REQUEST_AUTHORIZED_VENUES = 'REQUEST_AUTHORIZED_VENUES';
export const RECEIVE_AUTHORIZED_VENUES = 'RECEIVE_AUTHORIZED_VENUES';
export const REQUEST_UPDATE_VENUE = 'REQUEST_UPDATE_VENUE';
export const VENUE_UPDATED = 'VENUE_UPDATED';
export const SET_VENUE_STRIPE_TOKEN = 'SET_VENUE_STRIPE_TOKEN';
export const CLEAR_VENUE_DETAILS = 'CLEAR_VENUE_DETAILS';
export const REQUEST_AUTHORISED_USERS = 'REQUEST_AUTHORISED_USERS';
export const SET_AUTHORISED_USERS = 'SET_AUTHORISED_USERS';
export const REQUEST_MANAGED_PAGES = 'REQUEST_MANAGED_PAGES';
export const SET_MANAGED_PAGES = 'SET_MANAGED_PAGES';
export const REQUEST_FATSOMA_PAGE = 'REQUEST_FATSOMA_PAGE';
export const SET_FATSOMA_PAGE = 'SET_FATSOMA_PAGE';
export const SET_SELECTED_SUBSCRIPTION_USER = 'SET_SELECTED_SUBSCRIPTION_USER';
export const REQUEST_CREATE_VENUE = 'REQUEST_CREATE_VENUE';
export const SET_VENUE_CREATED = 'SET_VENUE_CREATED';
export const BEGIN_IMAGE_UPLOAD = 'BEGIN_IMAGE_UPLOAD';
export const FINISH_IMAGE_UPLOAD = 'FINISH_IMAGE_UPLOAD';
export const SET_UPLOADED_IMAGE_URL = 'SET_UPLOADED_IMAGE_URL';

const requestDefaultVenue = () => ({
  type: REQUEST_DEFAULT_VENUE,
  payload: {
    fetchingDefaultVenue: true,
  },
});

export const setDefaultVenue = venue => ({
  type: SET_DEFAULT_VENUE,
  payload: {
    defaultVenue: venue,
    fetchingDefaultVenue: false,
  },
});

const requestAllMenus = () => ({
  type: REQUEST_ALL_MENUS,
  payload: {
    fetchingMenus: true,
  },
});

export const receiveAllMenus = menus => {
  return {
    type: RECEIVE_ALL_MENUS,
    payload: {
      fetchingMenus: false,
      menus: menus,
      errorFetchingMenus: menus == null,
    },
  };
};

const requestVenueDetails = () => ({
  type: REQUEST_VENUE_DETAILS,
  payload: {
    fetchingVenue: true,
    venueFetchError: {},
  },
});

export const setVenueDetails = venue => {
  return {
    type: SET_VENUE_DETAILS,
    payload: {
      ...venue,
      fetchingVenue: false,
    },
  };
};

export const clearVenueFlags = () => {
  return {
    type: CLEAR_VENUE_DETAILS,
    payload: {
      fetchingVenue: false,
      fetchingDefaultVenue: false,
      fetchingMenus: false,
      venuCreated: false,
      updatingVenue: false,
      fetchingAuthorisedUsers: false,
      fetchingAuthorizedVenues: false,
    },
  };
};

export const setVenueStripeToken = stripeToken => {
  return {
    type: SET_VENUE_STRIPE_TOKEN,
    payload: {
      stripe_token: stripeToken,
    },
  };
};

const requestUpdateVenue = () => ({
  type: REQUEST_UPDATE_VENUE,
  payload: {
    updatingVenue: true,
    venueUpdated: false,
  },
});

const venueUpdated = success => ({
  type: VENUE_UPDATED,
  payload: {
    updatingVenue: false,
    venueUpdated: success,
  },
});

const beginUploadingImage = () => ({
  type: BEGIN_IMAGE_UPLOAD,
  payload: {
    uploadingImage: true,
  },
});

const finishUploadingImage = () => ({
  type: FINISH_IMAGE_UPLOAD,
  payload: {
    uploadingImage: false,
  },
});

const setUploadedImageURL = url => ({
  type: SET_UPLOADED_IMAGE_URL,
  payload: {
    uploadedImageURL: url,
  },
});

const requestAuthorizedVenues = query => {
  return {
    type: REQUEST_AUTHORIZED_VENUES,
    payload: {
      fetchingAuthorizedVenues: true,
    },
  };
};

const receiveAuthorizedVenues = venueList => {
  return {
    type: RECEIVE_AUTHORIZED_VENUES,
    payload: {
      fetchingAuthorizedVenues: false,
      venueSwitcherSearchResults: venueList,
    },
  };
};

const requestAuthorisedUsers = () => {
  return {
    type: REQUEST_AUTHORISED_USERS,
    payload: {
      fetchingAuthorisedUsers: true,
      authorisedUsersFetched: false,
      authorisedUsersError: null,
    },
  };
};

export const setSelectedSubscriptionUser = user => {
  return {
    type: SET_SELECTED_SUBSCRIPTION_USER,
    payload: {
      selectedSubscriptionUser: user,
    },
  };
};

const setAuthorisedUsers = (users, err = null) => {
  return {
    type: SET_AUTHORISED_USERS,
    payload: {
      fetchingAuthorisedUsers: false,
      authorisedUsersFetched: err == null,
      authorisedUsersError: err,
      authorisedUsers: users,
    },
  };
};

const requestManagedPages = () => {
  return {
    type: REQUEST_MANAGED_PAGES,
    payload: {
      fetchingManagedPages: true,
      managedPagesFetched: false,
      managedPagesError: null,
    },
  };
};

const setManagedPages = (pages, meta = {}, err = null) => {
  return {
    type: SET_MANAGED_PAGES,
    payload: {
      fetchingManagedPages: false,
      managedPagesFetched: err == null,
      managedPagesError: err,
      managedPagesQueryable: Boolean(meta.has_more),
      managedPages: pages,
    },
  };
};

const requestFatsomaPage = () => {
  return {
    type: REQUEST_FATSOMA_PAGE,
    payload: {
      fetchingFatsomaPage: true,
      fatsomaPageFetched: false,
      fatsomaPageError: null,
    },
  };
};

const setFatsomaPage = (page, err = null) => {
  return {
    type: SET_FATSOMA_PAGE,
    payload: {
      fetchingFatsomaPage: false,
      fatsomaPageFetched: err == null,
      fatsomaPageError: err,
      fatsomaPage: page,
    },
  };
};

const requestCreateVenue = () => {
  return {
    type: REQUEST_CREATE_VENUE,
    payload: {
      creatingVenue: true,
      venueCreated: false,
    },
  };
};

const setVenueCreated = err => {
  return {
    type: SET_VENUE_CREATED,
    payload: {
      creatingVenue: false,
      venueCreated: err == null,
    },
  };
};

export const uploadVenueImage = data => {
  return dispatch => {
    dispatch(beginUploadingImage());

    const apiRequest = UploadVenueImageAPIRequest({
      file_base64_data: data,
      purpose: 'Venue Image',
    });

    return callAPI(apiRequest)
      .then(json => {
        dispatch(setUploadedImageURL(json.file));
        dispatch(finishUploadingImage());
      })
      .catch(err => {
        dispatch(finishUploadingImage());
      });
  };
};

export const fetchAuthorisedUsers = () => {
  return dispatch => {
    dispatch(requestAuthorisedUsers());

    const apiRequest = FetchAuthorisedUsersAPIRequest();

    return callAPI(apiRequest)
      .then(json => dispatch(setAuthorisedUsers(json.users)))
      .catch(err => {
        dispatch(setAuthorisedUsers([], err));
      });
  };
};

export const fetchManagedPages = data => {
  return dispatch => {
    dispatch(requestManagedPages());

    const { query } = data;
    const apiRequest = FetchManagedPagesAPIRequest({
      ...(query && query !== '' ? { query } : {}),
    });

    return callAPI(apiRequest)
      .then(json => dispatch(setManagedPages(json.pages, json.meta)))
      .catch(err => {
        dispatch(setManagedPages([], {}, err));
      });
  };
};

export const fetchFatsomaPage = data => {
  return dispatch => {
    dispatch(requestFatsomaPage());

    return callJSONAPI(FetchPageFatsomaAPIRequest(data))
      .then(json => dispatch(setFatsomaPage(json)))
      .catch(err => {
        dispatch(setFatsomaPage({}, err));
      });
  };
};

export const createVenue = data => {
  return async dispatch => {
    dispatch(requestCreateVenue());

    const apiRequest = CreateVenueAPIRequest(data);

    try {
      window.Intercom('trackEvent', 'created-venue');
      await callAPI(apiRequest);

      dispatch(setHasVenues(true));
      dispatch(setVenueCreated(null));
    } catch (err) {
      dispatch(setError(err));
      dispatch(setVenueCreated(err));
    }
  };
};

export const fetchAllMenus = () => {
  return dispatch => {
    dispatch(requestAllMenus());

    // TODO: Menu call
    const apiRequest = FetchAllMenusAPIRequest();

    return callAPI(apiRequest)
      .then(json => dispatch(receiveAllMenus(json.menus)))
      .catch(err => {
        dispatch(setError(err));
        dispatch(receiveAllMenus(null));
      });
  };
};

export const fetchDefaultVenue = () => {
  return dispatch => {
    dispatch(requestDefaultVenue());

    const apiRequest = DefaultVenueAPIRequest();

    return callAPI(apiRequest)
      .then(json => dispatch(setDefaultVenue(json.default)))
      .catch(err => {
        dispatch(setError(err));
        dispatch(setDefaultVenue(null));
      });
  };
};

export const updateVenue = data => {
  return dispatch => {
    dispatch(requestUpdateVenue());

    const apiRequest = UpdateVenueAPIRequest({ changes: data });

    return callAPI(apiRequest)
      .then(json => {
        dispatch(setVenueDetails(json.venue));
        dispatch(venueUpdated(true));
      })
      .catch(err => dispatch(venueUpdated(false)));
  };
};

export const fetchVenueDetails = () => {
  return dispatch => {
    dispatch(requestVenueDetails());

    const apiRequest = VenueDetailsAPIRequest();

    return callAPI(apiRequest)
      .then(json => dispatch(setVenueDetails(json.venue)))
      .catch(err => {
        dispatch(setError(err));
        dispatch(setVenueDetails(null));
      });
  };
};

export const queryAuthorizedVenues = query => {
  return dispatch => {
    dispatch(requestAuthorizedVenues(query));

    const apiRequest = QueryAuthorizedVenuesAPIRequest({
      query: query,
    });

    return callAPI(apiRequest, true)
      .then(json => dispatch(receiveAuthorizedVenues(json.venues || [])))
      .catch(err => {
        dispatch(setError(err));
        dispatch(receiveAuthorizedVenues([]));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/venue/index.js